import * as React from 'react';
export const lightBulbSvg = React.forwardRef(function lightBulbSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5 13.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm1 1.25h4v.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.05 8.014c.594-.691.95-1.583.95-2.56C12 3.283 10.22 1.5 8 1.5c-2.22 0-4 1.782-4 3.955 0 .976.356 1.868.95 2.56.522.605 1.067 1.452 1.213 2.485h3.674c.146-1.033.691-1.88 1.212-2.486Zm1.136.978c-.498.58-.886 1.277-.886 2.04a.967.967 0 0 1-.967.968H5.667a.967.967 0 0 1-.967-.967c0-.764-.388-1.461-.886-2.04A5.407 5.407 0 0 1 2.5 5.454C2.5 2.442 4.962 0 8 0s5.5 2.442 5.5 5.455c0 1.35-.495 2.585-1.314 3.537Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.125 4.25c-.76 0-1.375.616-1.375 1.375a.625.625 0 1 1-1.25 0A2.625 2.625 0 0 1 8.125 3a.625.625 0 1 1 0 1.25Z',
    }),
  );
});
lightBulbSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lightBulb = {
  category: 'icon',
  colorable: true,
  name: 'lightBulb',
  svg: lightBulbSvg,
};
